/** Ścieżki SPA bez sesji — te same co PUBLIC_SPA_PATHS w app/spa.py. */
const PUBLIC_SEGMENTS = new Set([
  "login",
  "register",
  "register-pending",
  "forgot-password",
  "reset-password",
  "verify-email",
  "account-deletion-cancel",
  "welcome",
  "privacy",
  "terms",
  "google-consent",
]);

/**
 * Czy bieżący URL to strona publiczna (logowanie, reset hasła, landing).
 * pathname z window to zwykle `/app/reset-password`.
 */
export function isPublicAuthPath(pathname: string = window.location.pathname): boolean {
  const trimmed = pathname.replace(/\/+$/, "") || "/";
  const withoutApp = trimmed === "/app" ? "/" : trimmed.replace(/^\/app(?=\/|$)/, "");
  const segment = withoutApp.replace(/^\//, "").split("/")[0] ?? "";
  return PUBLIC_SEGMENTS.has(segment);
}
